<div class="p500-ui-modal__inner">
  <form class="c-form c-form--d" (ngSubmit)="submit()" [formGroup]="form">
    <div class="c-modal__head">
      <div class="row">
        <div class="c-modal__close" (click)="close(); $event.preventDefault()">
          <p500-ui-icon name="close" size="20px"></p500-ui-icon>
        </div>
        <div class="c-modal__title col-12">{{ title }}</div>
        <div class="c-modal__subtitle col-12">{{ description }}</div>
      </div>
    </div>

    <div class="p500-ui-modal__body">
      <p500-ui-cube-preloader [hidden]="!isLoading"></p500-ui-cube-preloader>
      <div class="p500-ui-modal__group" [hidden]="isLoading">
        <div class="head">
          <div class="p500-ui-modal__body-title"></div>
        </div>
        <div class="row">
          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-text-field [formControl]="nameControl" i18n-label="@@common.name" label="Name" [required]="true">
              </p500-ui-text-field>
            </div>
          </div>

          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                [formControl]="formatControl"
                i18n-label="@@common.format"
                label="Format"
                [data]="formats"
                [required]="true"
              >
              </p500-ui-select-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="c-form__section col-12" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-text-field
                [formControl]="descriptionControl"
                i18n-label="@@common_description"
                label="Description"
              ></p500-ui-text-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                [formControl]="modelControl"
                i18n-label="@@common.model"
                label="Model"
                [data]="models"
                [required]="true"
                (ngModelChange)="onModelChange($event)"
              >
              </p500-ui-select-field>
            </div>
          </div>

          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                [formControl]="dateTypeControl"
                i18n-label="@@common.date_type"
                label="Date Type"
                [data]="dateTypes"
                [required]="true"
              >
              </p500-ui-select-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                [formControl]="targetControl"
                i18n-label="@@common.target"
                label="Target"
                [data]="targets"
                [required]="true"
                [disabled]="!modelControl.value"
                (ngModelChange)="onTargetChange($event)"
              >
              </p500-ui-select-field>
            </div>
          </div>

          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                [formControl]="aggregateControl"
                i18n-label="@@common.aggregate"
                label="Aggregate"
                [data]="aggregates"
                [required]="true"
                [disabled]="!modelControl.value || !targetControl.value"
              >
              </p500-ui-select-field>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="postProcessorControl.value">
          <div class="c-form__section col-6" gtdFieldWidth>
            <gtd-slide-toggle-with-hint
              [control]="postProcessorOnControl"
              [hintModal]="true"
              [tooltipHint]="MODAL_TOOLTIP_KEY_ENUM.BASE_METRIC_NEGATIVE_PAYOUT"
              i18n-label="@@settings.prevent_negative_value"
              label="Prevent Negative Values"
            ></gtd-slide-toggle-with-hint>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="c-form--d c-form__section -full-width">
          <div class="d-flex">
            <span class="fw-bold mr-10 ml-10" i18n="@@common.conditions">Conditions</span>
            <button
              p500-ui-circled-button
              size="small"
              color="primary"
              type="button"
              [disabled]="!modelControl.value"
              (click)="addFilter()"
            >
              <p500-ui-icon name="plus"></p500-ui-icon>
            </button>
          </div>
          <div class="c-form--d c-form__section-splitter">
            <div class="-splitter-body"></div>
          </div>
        </div>
      </div>

      <ng-container *ngFor="let group of filtersControl.controls; index as i" [formGroup]="group">
        <div class="row">
          <div class="c-form__section col-4" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                formControlName="field"
                i18n-label="@@common.filter"
                label="Filter"
                [data]="getFiltersOptions(group.get('field').value)"
                [disabled]="!modelControl.value"
                (ngModelChange)="conditionFieldChanged(group)"
              >
              </p500-ui-select-field>
            </div>
          </div>

          <div class="c-form__section col-3" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                formControlName="operator"
                i18n-label="@@common.sign"
                label="Sign"
                [data]="getOperatorsOptions(group.get('field').value)"
                [disabled]="!group.get('field').value"
              >
              </p500-ui-select-field>
            </div>
          </div>

          <div class="c-form__section col-4" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <ng-container [ngSwitch]="getSelectType(group.get('field').value)">
                <p500-ui-select-with-icon-field
                  *ngSwitchCase="'countries'"
                  [data]="globalData.countries"
                  [disabled]="!group.get('field').value"
                  i18n-label="@@common.value"
                  label="Value"
                  [multiple]="true"
                  formControlName="value"
                >
                </p500-ui-select-with-icon-field>
                <p500-ui-boolean-select-field
                  *ngSwitchCase="'bool'"
                  [disabled]="!group.get('field').value"
                  i18n-label="@@common.value"
                  label="Value"
                  formControlName="value"
                ></p500-ui-boolean-select-field>
                <p500-ui-number-field
                  *ngSwitchCase="'money'"
                  [disabled]="!group.get('field').value"
                  i18n-label="@@common.value"
                  label="Value"
                  formControlName="value"
                ></p500-ui-number-field>
                <p500-ui-select-field
                  *ngSwitchCase="'payout_models'"
                  [data]="globalData[getFilterType(group.get('field').value)]"
                  [disabled]="!group.get('field').value"
                  i18n-label="@@common.value"
                  label="Value"
                  [multiple]="true"
                  bindLabel="name"
                  formControlName="value"
                >
                  <ng-template let-data="data" p500UIFieldTemplate>
                    {{ data.value.name }}
                  </ng-template>
                </p500-ui-select-field>
                <p500-ui-select-field
                  *ngSwitchCase="'revenue_models'"
                  [data]="globalData[getFilterType(group.get('field').value)]"
                  [disabled]="!group.get('field').value"
                  i18n-label="@@common.value"
                  label="Value"
                  [multiple]="true"
                  formControlName="value"
                >
                  <ng-template let-data="data" p500UIFieldTemplate>
                    {{ data.value.name }}
                  </ng-template>
                </p500-ui-select-field>
                <gtd-currency-select
                  *ngSwitchCase="'available_offer_currencies'"
                  i18n-label="@@common.value"
                  label="Value"
                  [acceptedCurrencyList]="globalData.offer_currencies_options"
                  [multiple]="true"
                  formControlName="value"
                >
                </gtd-currency-select>
                <p500-ui-select-field
                  *ngSwitchCase="'global-data-select'"
                  [data]="globalData[getFilterType(group.get('field').value)]"
                  [disabled]="!group.get('field').value"
                  i18n-label="@@common.value"
                  label="Value"
                  [multiple]="true"
                  formControlName="value"
                ></p500-ui-select-field>
                <p500-ui-text-field
                  *ngSwitchDefault
                  [disabled]="!group.get('field').value"
                  i18n-label="@@common.value"
                  label="Value"
                  formControlName="value"
                ></p500-ui-text-field>
              </ng-container>
            </div>
          </div>

          <div class="c-form__section col-1" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <button
                p500-ui-circled-button
                size="small"
                type="button"
                color="warn"
                class="ml-10 mb-6 align-self-end mt-30"
                [transparent]="true"
                (click)="removeFilter(i)"
              >
                <p500-ui-icon name="close"></p500-ui-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="c-modal__footer">
      <div class="d-flex">
        <div class="c-modal__action" (click)="close(); $event.preventDefault()">
          <button type="button" p500-ui-button stroked="true" i18n="@@common.cancel">Cancel</button>
        </div>
        <div class="c-modal__action">
          <button
            type="submit"
            p500-ui-button
            classIcon="p500-ui-icon-check"
            positionIcon="right"
            [disabled]="form.invalid || isLoading"
            i18n="@@common.submit"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
